import React from "react";
import ComingSoonChip from "../coming-soon-chip/coming-soon-chip";
import styles from "./logs-tab-label.module.scss";

const LogsTabLabel = () => {
  return (
    <>
      <span className={styles.logsText}>Logs</span>
      <ComingSoonChip />
    </>
  );
};

export default LogsTabLabel;

